import { render, staticRenderFns } from "./PatientCheckConfig.vue?vue&type=template&id=f04a8420&scoped=true"
import script from "./PatientCheckConfig.vue?vue&type=script&lang=js"
export * from "./PatientCheckConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a8420",
  null
  
)

export default component.exports